<template>
  <!-- This template is connector archive and it is used in both organisation and archive -->
  <v-col class="px-0 py-0">
    <x-org-heading v-if="type === 'configuration'" :heading="heading" />
    <v-row no-gutters v-if="showAdvanceSearch">
      <v-col>
        <!-- Need to replace isTeamsArchive &  isDropboxArchive with common flag  -->
        <VaultAdvanceSearch
          :defaultState="defaultExpanded"
          :isTeamsArchive="isTeamsArchive"
          :isDropboxArchive="isDropboxArchive"
        />
      </v-col>
    </v-row>
    <x-dialog
      v-if="from === 'DISCOVERY'"
      width="75%"
      :dialogTitle="connectorDetail.source.name"
      :dialogState="connectorDetailModalState"
      @toggleModal="val => (connectorDetailModalState = val)"
    >
      <template slot="dialog_data">
        <VaultArchiveDetail
          v-if="connectorDetailModalState"
          :propsItemId="connectorDetail.source.itemId"
          :propsSourceType="connectorDetail.source.sourceType"
          :propsArchiveId="connectorDetail.archiveId"
          :openInModal="true"
        />
      </template>
    </x-dialog>
    <x-table
      :data-test-id="tableDataTestId"
      :showSelectAll="showCheckbox"
      :columns="columns"
      :updateTableSize="updatePageSize"
      :sortBy="sortBy"
      :selectAllItems="selectAllItems"
      :changeCheckState="checkState"
      :loading="loading"
      :selectedItems="selectedItems"
      :tableRows="tableRows"
      :paginationData="{ pageSize, pageNumber, totalRecords, setPage }"
    >
      <template v-if="selectedItems.length" slot="table-top-right">
        <v-row class="justify-end" no-gutters v-if="from === 'ORG'">
          <ExportOptionsModal
            v-if="exportDialogState"
            :operationType="operationType"
            :exportJobInProgress="checkState"
            @closeDialog="toggleExportModal"
            @triggerExport="restoreArchive"
          />
          <!-- // TODO: Move to  reusable component actionButton -->
          <x-button
            color="#58e2c2"
            @click="chooseOperation"
            class="ml-3"
            :buttonText="operationType"
            :data-test-id="`${tableDataTestId}__export-restore-btn`"
          />
        </v-row>
        <x-button
          v-if="from === 'DISCOVERY'"
          v-show="someArchivesSelected"
          class="w-auto v-btn"
          buttonText="Add to Saved Items"
          @click="addToSaved"
          color="#58e2c2"
          :data-test-id="`${tableDataTestId}__add-to-saved-btn`"
        />
      </template>

      <template slot="table_item" slot-scope="props">
        <component
          :selectItem="selectItem"
          :is="DriveShareTableRow"
          @openInModal="openInModal"
          :from="from"
          :type="type"
          :selectedItems="props.selectedItems"
          :tableRows="props.tableRows"
          :showCheckbox="showCheckbox"
          :data-test-id="tableDataTestId"
        ></component>
      </template>
    </x-table>
    <loader v-if="checkState" />
  </v-col>
</template>
<script>
import EmailCount from '@/components/Common/TableRecordDisplaySelector';
import VaultAdvanceSearch from './VaultAdvanceSearch';
import EventBus from '@/EventBus';
import DriveShareTableRow from './DriveShareTableRow';
import VaultArchiveDetail from './VaultArchiveDetail';
import {
  getTableColumns,
  selectAll,
  getSortedColumns,
  defaultTableProps
} from '@/helpers/TableHelpers';
import { mapState } from 'vuex';
import { CancelToken } from 'axios';
const ExportOptionsModal = () =>
  import('@/components/ArchiveSearch/ExportOptionsModal/ExportOptionsModal');
export default {
  components: {
    EmailCount,
    VaultAdvanceSearch,
    DriveShareTableRow,
    VaultArchiveDetail,
    ExportOptionsModal
  },
  mounted() {
    this.initTableData();
    this.initAdvanceSearch();
    EventBus.$on('SearchDTO', value => {
      this.pageNumber = defaultTableProps.pageNumber;
      this.advanceSearchParams = value;
      this.updateRoute('advanceSearchParams');
    });
    this.getArchives();
  },
  computed: {
    ...mapState([
      'currentlySelectedOrgId',
      'activeConnectors',
      'projectDetails'
    ]),
    someArchivesSelected() {
      return (this.selectedItems || []).length;
    },
    showCheckbox() {
      if (this.from === 'DISCOVERY') {
        return (
          this.projectDetails.projectStatus !==
          this.$enums.projectStatus.ARCHIVED
        );
      }
      return true;
    },
    connectorType() {
      return this.$route.params?.connectorType || '';
    },
    connectorId() {
      return this.connectorArchiveNameMap(this.connectorType)?.id || '';
    },
    projectId() {
      return this.$route.params?.projectId || '';
    },
    isTeamsArchive() {
      return this.connectorType?.toLocaleLowerCase() === 'teams';
    },
    isDropboxArchive() {
      return this.connectorType?.toLocaleLowerCase() === 'dropbox';
    },
    operationType() {
      return this.isTeamsArchive || !this.connectorType ? 'Export' : 'Restore';
    },
    isOrgOnboarded() {
      return this.onboardingStatus === this.$enums.onboardingStatus.done;
    }
  },
  props: {
    defaultExpanded: { type: Boolean, default: false },
    showAdvanceSearch: { type: Boolean, default: true },
    from: { type: String, default: 'ORG' },
    type: { type: String }
  },
  watch: {
    activeConnectors: function() {
      if (!this.connectorArchiveNameMap(null, 'consentMenu').length) {
        this.initalRoute('GO_TO_INITAL');
      }
    },
    currentlySelectedOrgId: function() {
      if (!this.checkPagePermission()) {
        this.snackbar('error', this.$message.NO_PERMISSION);
        this.initalRoute('GO_TO_INITAL');
        return;
      }
      this.getArchives();
    },
    // whenever the route is changed
    // it changes the this.pageNumber
    // gets data based on changed pageNumber
    $route() {
      this.getArchives();
    }
  },
  methods: {
    /**
     * Initialize table related data like pageNumber, pageSize, sortOrder, sortBy & columns
     */
    initTableData() {
      this.columns = this.copyArray(
        getTableColumns(this.isTeamsArchive ? 'teams' : 'vault')
      );

      // TODO: Need to remove

      if (this.isTeamsArchive) {
        this.columns[0].field = 'NAME';
        // eslint-disable-next-line
        this.columns[2].field = 'CREATED_ON';
        // eslint-disable-next-line
        this.columns[3].field = 'UPDATED_ON';
      } else if (
        this.$route.meta?.fromType === 'org-vault' ||
        this.type === 'discovery' ||
        this.isDropboxArchive
      ) {
        this.columns[0].field = 'NAME';
        // eslint-disable-next-line
        this.columns[1].field = 'SIZE';
        // eslint-disable-next-line
        this.columns[2].field = 'SOURCE_TYPE';
        // eslint-disable-next-line
        this.columns[4].field = 'CREATED_ON';
        // eslint-disable-next-line
        this.columns[5].field = 'UPDATED_ON';
        // eslint-disable-next-line
        this.columns[6].field = 'VERSION';
      }
      // set table sortBy & sortOrder
      const { sortOrder } = defaultTableProps;

      // eslint-disable-next-line
      this.searchParams = { sortBy: this.columns[0].field, sortOrder };
      this.searchParams = this.getRouteParamValue(
        'query',
        'qs',
        this.searchParams
      );
      // set table columns

      // Check to manipulate column name
      // if :- tab is either 'Organisation Vault' under Archive Search or 'Vault archive' under discovery project
      // then :- manipulate column name
      if (
        this.canViewTeams('o365_teams') &&
        (this.$route.meta?.fromType === 'org-vault' ||
          this.type === 'discovery')
      ) {
        this.columns[0].label = 'Name';
      }

      this.columns = getSortedColumns(
        this.columns,
        this.searchParams.sortBy,
        this.searchParams.sortOrder
      );
      this.pageNumber = this.getRouteParamValue(
        'params',
        'pageNumber',
        defaultTableProps.pageNumber,
        true
      );
      this.pageSize = this.getRouteParamValue(
        'query',
        'pageSize',
        defaultTableProps.pageSize,
        true
      );
    },

    /**
     * To initialize advance search filters
     */
    initAdvanceSearch() {
      this.advanceSearchParams = this.getRouteParamValue(
        'query',
        'advanceSearchParams',
        this.advanceSearchParams
      );
    },

    /**
     * Reusable function to update route query params
     *
     * @param {String} queryParamName
     */
    updateRoute(queryParamName, value = queryParamName) {
      const { qs, advanceSearchParams } = this.$route.query;
      const queryParams = {
        pageSize: this.pageSize,
        qs: qs ?? JSON.stringify(this.searchParams),
        advanceSearchParams:
          advanceSearchParams ?? JSON.stringify(this.advanceSearchParams)
      };
      queryParams[queryParamName] = JSON.stringify(this[value]);
      this.$router.push({ path: `p${this.pageNumber}`, query: queryParams });
    },

    openInModal(modalState, item) {
      this.connectorDetail = item;
      this.connectorDetailModalState = modalState;
    },

    checkPagePermission() {
      if (this.isOwnOrgSelected()) {
        // wants to search in own org
        return this.$can('search', 'organisation_toolbox_archives');
      } else {
        // wants to search in child org
        return this.$can('search', 'child_organisation_toolbox_archives');
      }
    },

    /**
     * Set Page number
     */
    async setPage(pageNumber) {
      this.pageNumber = pageNumber;
      if (parseInt(this.$route.params.pageNumber, 10) !== this.pageNumber) {
        this.updateRoute('qs', 'searchParams');
      } else {
        this.getArchives();
      }
    },

    async addToSaved() {
      this.checkState = true;
      if (!this.someArchivesSelected) {
        this.snackbar('error', this.$message.SELECT_ITEMS);
        return false;
      }
      this.overlay = true;
      try {
        await this.$services.project.addArchives(this.projectId, {
          archives: this.selectedItems,
          archiveType: this.$enums.archiveType.VAULT
        });
        this.snackbar('success', this.$message.ITEMS_SAVED);
        this.selectedItems = [];
        this.setPage(defaultTableProps.pageNumber);
        EventBus.$emit('REFRESH_COLLABORATORS', true);
        this.overlay = false;
      } catch (err) {
        this.snackbar('error', this.$message.ERROR);
        this.overlay = false;
      }
      this.checkState = false;
    },

    selectItem(val) {
      this.selectedItems = val;
    },

    selectAllItems(status) {
      this.selectedItems = selectAll({
        status,
        key: 'archiveId',
        data: this.tableRows
      });
    },

    /**
     * To update Page Size
     */
    updatePageSize(pageSize) {
      this.pageSize = pageSize;
      this.pageNumber = defaultTableProps.pageNumber;
      this.updateRoute('pageSize');
    },

    /**
     * To restore Archive
     */
    async restoreArchive(exportTo) {
      try {
        this.checkState = true;
        if (this.someArchivesSelected) {
          const restoreArchiveObject = {};
          this.selectedItems.forEach(selectedArchive => {
            const restoreArchive = this.tableRows.find(
              archive => archive.archiveId === selectedArchive
            );
            if (restoreArchive) {
              restoreArchiveObject[restoreArchive.source.sourceType] = [
                ...(restoreArchiveObject[restoreArchive.source.sourceType]
                  ? [...restoreArchiveObject[restoreArchive.source.sourceType]]
                  : []),

                restoreArchive.source.sourceType === 'o365_teams'
                  ? restoreArchive.archiveId
                  : restoreArchive.archiveId
              ];
            }
          });

          const response = await this.$services.vaultData.restoreArchiveFile({
            type: this.type,
            archives: restoreArchiveObject,
            exportTo: exportTo || this.connectorId,
            action: this.operationType.toLowerCase()
          });

          const parsedResponse = this.parseResponse(response);
          if (parsedResponse) {
            const connectorName =
              this.connectorArchiveNameMap(exportTo || this.connectorId)
                ?.title || '';

            this.snackbar(
              'success',
              this.operationType === 'Export'
                ? this.$message.EXPORT_QUEUED(connectorName)
                : this.$message.QUEUED
            );
            if (this.operationType === 'Export') {
              this.toggleExportModal();
            }
            this.selectedItems = [];
          } else {
            this.snackbar('error', this.$message.ERROR);
          }
        } else {
          this.snackbar('info', this.$message.SELECT_FIELD);
        }
      } catch (error) {
        if (
          error?.response?.data?.errors?.[0]?.message ===
          'Your previous request is already in progress!'
        ) {
          this.snackbar('info', error?.response?.data?.errors?.[0]?.message);
        } else {
          this.snackbar('error', error);
        }
      } finally {
        this.checkState = false;
      }
    },

    /**
     * To download archives
     */
    async downloadArchive() {
      this.checkState = true;
      if (this.selectedItems.length) {
        let downloadArchiveArray = [];
        this.selectedItems.forEach(selectedArchive => {
          const downloadArchive = this.tableRows.find(
            archive => archive.archiveId === selectedArchive
          );
          if (downloadArchive) {
            downloadArchiveArray.push({
              itemId:
                downloadArchive.source.sourceType !== 'o365_teams'
                  ? downloadArchive.source.itemId
                  : downloadArchive.archiveId,
              version: downloadArchive.source.version || 1,
              sourceType: downloadArchive.source.sourceType
            });
          }
        });
        const response = await this.$services.vaultData.donwloadMultipleArchive(
          {
            type: this.type,
            archives: downloadArchiveArray
          },
          this.connectorType
        );

        if (response) {
          await this.$services.download.downloadZipFile(response);
          this.snackbar('success', 'Downloaded !');
          this.selectedItems = [];
        } else {
          this.snackbar('error', this.$message.ERROR);
        }
      } else {
        this.snackbar('info', this.$message.SELECT_FIELD);
      }
      this.checkState = false;
    },

    /**
     * To set table data by getting archives
     */
    async getArchives(value = {}) {
      try {
        this.loading = true;
        this.tableRows = [];
        let vaultArchivesData;
        const queryParams = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          type: this.from,
          projectId: this.projectId
        };
        const postBody = {
          ...this.searchParams,
          ...this.advanceSearchParams,
          ...value
        };
        if (this.type === 'configuration' || this.type === 'discovery') {
          vaultArchivesData = await this.$services.vaultData.getConnectorData(
            queryParams,
            postBody,
            this.axiosSource.token
          );
        } else {
          vaultArchivesData = await this.$services.vaultData.getUserConnectorData(
            queryParams,
            {
              ...postBody,
              sourceType: this.connectorArchiveNameMap(this.connectorType).id
            },
            //For Dropbox/Teams tab, go for v2
            this.isTeamsArchive || this.isDropboxArchive ? 'v2' : 'v1',
            this.axiosSource.token
          );
        }
        const vaultArchives = this.parseResponse(vaultArchivesData);
        if (this.type === 'configuration') {
          this.tableRows = vaultArchives?.results || [];
          this.totalRecords = vaultArchives?.totalResults || 0;
        }
        // If active tab is other than :- Dropbox & Teams
        else if (!(this.isTeamsArchive || this.isDropboxArchive)) {
          this.tableRows = vaultArchives?.[0]?.results || [];
          this.totalRecords = vaultArchives?.[0]?.totalResults || 0;
        } else {
          this.tableRows = vaultArchives?.results || [];
          this.totalRecords = vaultArchives?.totalResults || 0;
        }
        // set owners
        const owners = [];
        this.tableRows.map(tableRecord => {
          const sourceDetails = tableRecord?.source;
          const tableColumnId = sourceDetails?.accessibleBy
            ? 'accessibleBy'
            : 'ownerIds';
          const userIds = (sourceDetails?.[tableColumnId] || []).map(
            userDetails =>
              (tableColumnId === 'ownerIds'
                ? userDetails
                : userDetails?.userId) || ''
          );

          owners.push(...userIds);
        });
        owners.length && this.addUserDetails([...new Set(owners)]);

        // show 'No search result' msg if totalRecords = 0 or tableRows = []
        if (!this.totalRecords && !this.tableRows.length) {
          this.snackbar('info', this.$message.NO_SEARCH_RESULTS);
        }
      } catch (err) {
        // In case of organisation not found it will return no records in table
        this.tableRows = [];
        this.totalRecords = 0;
        this.currentPageArchiveIndex = null;
        if (err.message !== this.$message.CANCELLED) {
          this.snackbar('error', err);
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * To sort table
     */
    sortBy(tableSortData) {
      this.searchParams = { ...tableSortData };
      this.updateRoute('qs', 'searchParams');
    },
    toggleExportModal() {
      this.exportDialogState = !this.exportDialogState;
    },
    chooseOperation() {
      if (!this.isOrgOnboarded) {
        this.snackbar(
          'info',
          this.$message.ACTION_RESTRICTION_WHILE_ONBOARDING
        );
        return;
      }

      if (this.operationType === 'Restore') {
        this.restoreArchive();
        return;
      }

      this.toggleExportModal();
    }
  },
  beforeDestroy() {
    // To cancel network call explicitly when user switch route before network call completes
    this.axiosSource.cancel(this.$message.CANCELLED);
  },
  data() {
    return {
      DriveShareTableRow,
      currentPageArchiveIndex: {},
      pageSize: 20,
      advanceSearchParams: {},
      totalRecords: 0,
      pageNumber: 1,
      tableRows: [],
      searchParams: {},
      selectedItems: [],
      connectorDetailModalState: false,
      connectorDetail: { source: {}, archiveId: '' },
      loading: false,
      columns: [],
      selectAll,
      checkState: null,
      heading: 'Vault Search',
      axiosSource: CancelToken.source(),
      tableDataTestId: 'vault-archives-table',
      exportDialogState: false
    };
  }
};
</script>
